import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function Hero() {
  const scrollToCheckout = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full max-w-4xl mx-auto px-4 py-12 md:py-16" data-id="element-89">
      <h1 className="text-2xl md:text-4xl font-bold text-center text-gray-900 leading-snug mb-6 max-w-3xl mx-auto" data-id="element-90">
        Reducí errores administrativos y riesgos laborales sin contratar
        consultores ni hacer cursos interminables.
      </h1>

      <div className="flex justify-center mb-8" data-id="element-91">
        <img src="https://cdn.magicpatterns.com/uploads/2SSafk8gv7SwYJAvEa3WPn/f9667a58-27f9-4045-b1f1-5269360eb44c-removebg-preview.png" alt="Kit Recursos Humanos en Orden" className="max-w-full h-auto w-full md:w-3/4 cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToCheckout} data-id="element-92" />
      </div>

      <p className="text-lg md:text-xl text-center text-gray-700 mb-8 leading-relaxed" data-id="element-93">
        Creado para quienes hacen RRHH en una PYME sin equipo, sin tiempo y con
        la responsabilidad de que todo salga bien.
      </p>

      <div className="flex flex-wrap justify-center items-center gap-2 sm:gap-3 mb-10" data-id="element-94">
        <span className="inline-flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-200 text-sm font-medium text-gray-800 whitespace-nowrap" data-id="element-95">
          📄 100% PDF
        </span>
        <span className="inline-flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-200 text-sm font-medium text-gray-800 whitespace-nowrap" data-id="element-96">
          ⚡️ Entrega Inmediata
        </span>
        <span className="inline-flex items-center gap-1.5 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-200 text-sm font-medium text-gray-800 whitespace-nowrap" data-id="element-97">
          📚 10 Módulos + 3 Bonos
        </span>
      </div>

      <div className="flex justify-center" data-id="element-98">
        <button onClick={scrollToCheckout} className="bg-gradient-to-r from-emerald-400 to-teal-400 text-white px-10 py-4 rounded-full text-lg font-semibold hover:shadow-2xl hover:scale-105 transition-all duration-300" data-id="element-99">
          Quiero mi pack RRHH ahora
        </button>
      </div>
    </section>;
}